import React from "react";
import { PostProperties } from "./AllPost";
import { Link } from "react-router-dom";

const Post: React.FC<PostProperties> = ({
  title,
  content,
  image,
  buttonText,
  buttonUrl,
  category,
}) => {
  return (
    <div className="overflow-hidden transition-transform duration-200 flex flex-col md:flex-row items-start mb-12">
      <img
        src={image}
        alt="Post cover"
        className="w-full md:w-60 h-auto md:h-60 object-cover mb-4 md:mb-0 md:mr-6"
      />
      <div className="flex-1">
        <h2 className="text-3xl mb-4">{title}</h2>
        <p className="text-base mb-4">{content}</p>
        <div className="mt-4">
          {category === "Lost Gem" ? (
            <a
              href={buttonUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#c1282dff] hover:bg-[#606060] text-white inline-block text-center font-mono py-2 px-4"
            >
              {buttonText}
            </a>
          ) : (
            <Link
              to={`/${buttonUrl}`}
              className="bg-[#c1282dff] hover:bg-[#606060] text-white inline-block text-center font-mono py-2 px-4"
            >
              {buttonText}
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default Post;
